module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_easter-ed70dbcfdf51dc3ddb3a4356cf9f81b8.png";